import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserLogin } from "utils/user";
import { pushNotification } from "utils/notifications";
import Layout from "containers/Layout";
import moment from "moment";
import TicketApi from "service/ticketApi";
import { Rating } from "react-simple-star-rating";
import { formatNumber } from "utils/currencyFormat";
import LayoutV2 from "containers/LayoutV2";

export const DanhGia = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchDanhSachTicket);
  const initDetail = {
    LichSuXuLy: [],
  };
  const [chiTietTicket, setChiTietTicket] = useState(initDetail);

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let idTicket = params.get("idTicket");

  const init = {
    ID: 0,
    IDTicket: formatNumber(idTicket),
    Name: getUserLogin().UserName,
    TieuDe: "",
    ChatLuongHoTro: 0,
    Comment: "",
    HoTro: true,
    NVHoTro: true,
    DeXuat: "",
    TicketKeyCode: "00000000-0000-0000-0000-000000000000",
  };
  const [dataDanhGia, setDataDanhGia] = useState(init);

  useEffect(() => {
    TicketApi.ChiTietTicket(idTicket).then((response) => {
      if (response.status === 200) {
        if (typeof response.data != "undefined") {
          setDataDanhGia({
            ...dataDanhGia,
            TieuDe: response.data.TieuDe,
          });
          setChiTietTicket({
            ...chiTietTicket,
            LichSuXuLy: response.data.LichSuXuLy,
          });
        }
      }
    });
  }, []);

  const onChangeText = (field, e) => updateStateThongTin(field, e.target.value);
  const updateStateThongTin = (field, value) => {
    const thongtin = { ...dataDanhGia };
    thongtin[field] = value;
    setDataDanhGia(thongtin);
  };

  const onChangeCheck = (value) => {
    const thongtin = { ...dataDanhGia };
    thongtin.HoTro = value;

    setDataDanhGia(thongtin);
  };

  const onChangeCheck1 = (value) => {
    const thongtin = { ...dataDanhGia };
    thongtin.NVHoTro = value;

    setDataDanhGia(thongtin);
  };

  // Catch Rating value

  const handleRating = (rate) => {
    const thongtin = { ...dataDanhGia };
    thongtin.ChatLuongHoTro = rate;
    setDataDanhGia(thongtin);
    // other logic
  };

  console.log(dataDanhGia, "dataDanhGiadataDanhGiadataDanhGia");

  const [hideButton, setHideButton] = useState(true);
  const QuayLaiDanhSach = () => {
    window.location.href = "/ticket/danhsach.aspx";
  };
  const addDanhGia = () => {
    const value = { ...dataDanhGia };

    if (value.ChatLuongHoTro === 0) {
      pushNotification(
        "Bạn chưa tích đánh giá sao hỗ trợ",
        "error",
        "TOP_RIGHT",
        2000
      );

      return;
    } else if (value.Comment === "") {
      pushNotification("Bạn chưa nhập nhận xét", "error", "TOP_RIGHT", 2000);

      return;
    }
    const param2 = value;
    var params1 = param2;
    TicketApi.addDanhGia(params1).then((response) => {
      console.log(response, "ok1111");
      if (response.status == 200) {
        setHideButton(false);
        pushNotification(
          "Thêm mới đánh giá thành công",
          "success",
          "TOP_RIGHT",
          2000
        );
        setTimeout(function () {
          window.location.href = "/ticket/danhsach.aspx";
        }, 2000);
      } else {
        pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
      }
    });
  };
  return (
    <>
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <h1 className="text-info-home"> Đánh giá Ticket</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light card-v2">
                  <div className="card-body card-body-v2">
                    <div className="main-content">
                      <div
                        className="Left808x200 Table-main-new"
                        style={{
                          paddingLeft: "40px",
                          paddingTop: "40px",
                          paddingRight: "40px",
                          borderTop: "1px sold red",
                          fontWeight: 300,
                        }}
                      >
                        <div className="form-danhgia-new">
                          <div className="row-ticket">
                            <h4 className="color-xanh-bold">
                              Chất lượng hỗ trợ:
                            </h4>
                            <div class="row">
                              <div class="col-sm-12">
                                <div className="form-dg">
                                  <p>
                                    “Đánh giá của bạn sẽ giúp chúng tôi hoàn
                                    thiện phần mềm tốt hơn"
                                  </p>
                                  <Rating
                                    onClick={handleRating}
                                    size={40}
                                    transition
                                    showTooltip={false}
                                    initialValue={dataDanhGia.ChatLuongHoTro}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row-ticket">
                            <h4 className="color-xanh-bold">
                              Nhận xét hỗ trợ ticket này
                            </h4>
                            <div class="row">
                              <div class="col-sm-6">
                                <div
                                  className="form-check-ticket"
                                  style={{ paddingLeft: "20px" }}
                                >
                                  <p>Việc hỗ trợ có kịp thời hay không:</p>
                                  <div
                                    class="check-wrap-ticket"
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    <div class="form-check-newMain">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="inlineCheckbox1"
                                        checked={dataDanhGia.HoTro}
                                        onChange={(e) => onChangeCheck(true)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineCheckbox1"
                                      >
                                        Có
                                      </label>
                                    </div>
                                    <div class="form-check-newMain">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="inlineCheckbox2"
                                        checked={!dataDanhGia.HoTro}
                                        onChange={(e) => onChangeCheck(false)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineCheckbox2"
                                      >
                                        Không
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div className="form-check-ticket">
                                  <p>Có nhân viên liên lạc để hỗ trợ bạn:</p>
                                  <div
                                    class="check-wrap-ticket"
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    <div
                                      class="form-check-newMain"
                                      style={{ paddingLeft: "20px" }}
                                    >
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="inlineCheckbox11"
                                        checked={dataDanhGia.NVHoTro}
                                        onChange={(e) => onChangeCheck1(true)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineCheckbox11"
                                      >
                                        Có
                                      </label>
                                    </div>
                                    <div
                                      class="form-check-newMain"
                                      style={{ paddingLeft: "20px" }}
                                    >
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        id="inlineCheckbox21"
                                        checked={!dataDanhGia.NVHoTro}
                                        onChange={(e) => onChangeCheck1(false)}
                                      />
                                      <label
                                        class="form-check-label"
                                        for="inlineCheckbox21"
                                      >
                                        Không
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-sm-12"
                                style={{ marginTop: "10px" }}
                              >
                                <textarea
                                  class="form-control text-left"
                                  id="Comment"
                                  placeholder="Nhập nhận xét"
                                  rows="3"
                                  cols="20"
                                  value={dataDanhGia.Comment}
                                  onChange={(e) => onChangeText("Comment", e)}
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row-ticket"
                            style={{ marginTop: "10px" }}
                          >
                            <h4 className="color-xanh-bold">
                              Bạn có đề xuất nâng cấp nào cho phần mềm hoàn
                              thiện hơn không?
                            </h4>
                            <div className="row">
                              <div class="col-sm-12">
                                <textarea
                                  class="form-control text-left"
                                  id="DeXuat"
                                  placeholder="Nhập nhận xét"
                                  rows="3"
                                  cols="20"
                                  value={dataDanhGia.DeXuat}
                                  onChange={(e) => onChangeText("DeXuat", e)}
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row-ticket"
                            style={{ marginTop: "10px" }}
                          >
                            <h4 className="color-xanh-bold">
                              Lịch sử thông tin hỗ trợ
                            </h4>
                            <div class="table-Main-content table-border-new2 table-border-popup">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      <span>Phản hồi</span>
                                    </th>
                                    <th class="text-center">
                                      <span>Trạng thái</span>
                                    </th>
                                    <th class="text-center">
                                      <span>Deadline</span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {typeof chiTietTicket.LichSuXuLy !=
                                    "undefined" &&
                                  chiTietTicket.LichSuXuLy.length > 0 ? (
                                    chiTietTicket.LichSuXuLy.map(
                                      (itemSelect, indexSelect) => {
                                        return (
                                          <>
                                            <tr class="">
                                              <td class="text-left">
                                                {itemSelect.NoiDung}
                                              </td>
                                              <td class="text-center">
                                                {itemSelect.TenTrangThai}
                                              </td>
                                              <td class="text-center">
                                                {itemSelect.Deadline ===
                                                "1900-01-01T00:00:00"
                                                  ? ""
                                                  : itemSelect.Deadline === null
                                                  ? ""
                                                  : moment(
                                                      itemSelect.Deadline
                                                    ).format("DD/MM/YYYY")}
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      }
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="3">Không có dữ liệu</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="bottom-white"
                        style={{ marginTop: "10px", textAlign: "right" }}
                      >
                        <div class="footer-bottom ">
                          <div class="footer-bottom-form">
                            <button
                              type="button"
                              class="btn btn-new-main btn-closenew"
                              style={{ marginRight: "40px" }}
                              onClick={QuayLaiDanhSach}
                            >
                              Quay lại
                            </button>
                            {hideButton === true && (
                              <button
                                type="button"
                                class="btn btn-new-main btn-checknew"
                                style={{ marginRight: "40px" }}
                                onClick={addDanhGia}
                              >
                                Đánh giá
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutV2>
    </>
  );
};
